import cx from "classnames";
import {
  VictoryBar,
  VictoryChart,
  VictoryAxis,
  VictoryLabel,
  Bar,
} from "victory";

import styles from "./AssetReturnsBarGraph.module.scss";

import { changeNumberFormatToIndianCurrency } from "../../../utils/normalizer/common";
import {
  DEFAULT_RETURNS_CURRENCY_CATEGORY,
  MIN_GRAPH_Y_VALUE,
} from "../../../constants/PastPerformanceCalculator";

const CustomBar = ({ categories, isCryptoReturnsHighest, ...props }) => (
  <Bar
    {...props}
    className={cx(
      styles.CustomBar,
      isCryptoReturnsHighest &&
        categories.find(
          (cat) =>
            cat.label === props.datum.x &&
            cat.type === DEFAULT_RETURNS_CURRENCY_CATEGORY,
        )
        ? styles.High
        : null,
    )}
  />
);

const AssetReturnsBarGraph = ({
  className,
  data,
  categories,
  isCryptoReturnsHighest = false,
}) => {
  return (
    <div className={className}>
      <VictoryChart
        width={250}
        height={250}
        padding={30}
        domainPadding={{ x: 10 }}
        vertical>
        <VictoryAxis
          tickLabelComponent={
            <VictoryLabel className={styles.CustomTickLabel} />
          }
          style={{
            axis: { stroke: "rgba(0, 0, 0, 0.1)" },
          }}
        />
        <VictoryBar
          dataComponent={
            <CustomBar
              categories={categories}
              isCryptoReturnsHighest={isCryptoReturnsHighest}
            />
          }
          categories={{
            x: categories.map((cat) => cat.label),
          }}
          y={(datum) => (datum.y > 0 ? datum.y + MIN_GRAPH_Y_VALUE : datum.y)}
          style={{
            data: {
              fill: ({ datum }) =>
                categories.find((cat) => cat.label === datum.x)?.barColor,
              stroke: ({ datum }) =>
                categories.find((cat) => cat.label === datum.x)?.borderColor,
              strokeWidth: 2,
            },
          }}
          cornerRadius={{ topLeft: () => 3, topRight: () => 3 }}
          labels={({ datum }) =>
            `₹ ${changeNumberFormatToIndianCurrency(Number(datum.y, 2))}`
          }
          data={data.filter(
            (d) => categories?.find((cat) => cat.label === d.x) !== undefined,
          )}
          labelComponent={
            <VictoryLabel
              verticalAnchor="middle"
              className={styles.CustomLabels}
            />
          }
          barWidth={26}
        />
      </VictoryChart>
    </div>
  );
};

export default AssetReturnsBarGraph;
